import { render } from "./CtaSection.vue?vue&type=template&id=908c985a&scoped=true"
import script from "./CtaSection.vue?vue&type=script&lang=js"
export * from "./CtaSection.vue?vue&type=script&lang=js"

import "./CtaSection.vue?vue&type=style&index=0&id=908c985a&scoped=true&lang=css"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908c985a"]])

export default __exports__